import AppProviders from '@/providers/AppProviders'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { flushPendingEvents } from './lib/analytics'

flushPendingEvents()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
	<React.StrictMode>
		<AppProviders>
			<App />
		</AppProviders>
	</React.StrictMode>,
)
